import GlobalMetrics from './GlobalMetrics';

export default GlobalMetrics;
